import { AclApiPermission } from './acl-permission.model';
import { AclResourceType } from './acl-resource-type.model';
import { AclRole } from './acl-role.model';
import { AclSubject, AclSubjectType } from './acl-subject.model';

export interface AclGrantReceiver {
  receiver_subject_type: AclSubjectType;
  receiver_subject_id: string;
}

export interface AclSetGrant extends AclGrantReceiver {
  role: AclRole;
}

export interface AclGrantHttpModel extends AclGrantReceiver {
  role?: AclRole;
  revoke: boolean;
}

export interface AclResource {
  resource_id: string;
  company_id?: string;
  space?: string;
  permissions: AclApiPermission[];
  role?: AclRole;
  direct_role?: AclRole;
}

export interface AclRoleAssignment {
  subject: AclSubject;
  role: AclRole;
  direct_role?: AclRole;
}

export type AclRoleAssignmentsByResourceId = Record<string, AclRoleAssignment[]>;
export type AclRoleAssignmentsState = Partial<Record<AclResourceType, AclRoleAssignmentsByResourceId>>;

export type AclResourcesState = Partial<Record<AclResourceType, AclResource[]>>;

export type AclRolesState = Record<AclResourceType, AclRole[]>;
export type AclRoleTooltipsState = Record<AclRole, Record<Partial<AclResourceType>, string>>;

export interface AclSetRoleHttpModel {
  resourceType: AclResourceType;
  resourceId: string;
  spaceId?: string;
  grant: AclSetGrant;
}

export enum AclStrategy {
  StoreFirst = 'store-first',
  ApiFirst = 'api-first',
  SkipStore = 'skip-store',
}

export interface AclOrgSpaceSettings {
  enable_fine_grained_roles: boolean;
}
